<template>
  <div>
    <CRow>
      <CCol sm="12">&nbsp;</CCol>
      <CCol sm="12">
        <GlobalTable
          :title="'Owner Coverage'"
          :fields="fields"
          :items="data"
          :editButton="true"
          :enableAddButton="true"
          :removeButton="true"
          :redirectDetail="false"
          :isLoading="isLoading"
          :withCard="false"
          @addForm="addForm"
          @editForm="editForm"
          @removeData="removeData"
        ></GlobalTable>
      </CCol>
    </CRow>
    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol lg="6">
            <CRow>
              <CCol lg="12">
                <CRow>
                  <CCol lg="6">
                    <div class="form-group">
                      <label for="province">Province</label>
                      <model-select
                        class="form-control"
                        id="province"
                        :options="provinceList"
                        v-model="$v.ownerCoverageForm.province.$model"
                        :isError="$v.ownerCoverageForm.province.$invalid"
                        @input="filterRegency"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.ownerCoverageForm.province.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Province should be filled.
                      </div>
                    </div>
                  </CCol>
                  <CCol lg="6">
                    <div class="form-group">
                      <label for="regency">Regency</label>
                      <model-select
                        class="form-control"
                        id="regency"
                        :options="regencyList"
                        v-model="$v.ownerCoverageForm.regencies.$model"
                        :isError="$v.ownerCoverageForm.regencies.$invalid"
                        @input="filterDistrict"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.ownerCoverageForm.regencies.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Please select one
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>

            <CRow>
              <CCol lg="12">
                <CRow>
                  <CCol lg="6">
                    <div class="form-group">
                      <label for="district">District</label>
                      <model-select
                        class="form-control"
                        id="district"
                        :options="districtList"
                        @input="filterVillage"
                        v-model="$v.ownerCoverageForm.district.$model"
                        :isError="$v.ownerCoverageForm.district.$invalid"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.ownerCoverageForm.district.$invalid"
                        class="invalid-feedback-custom"
                      >
                        District should be filled.
                      </div>
                    </div>
                  </CCol>
                  <CCol lg="6">
                    <div class="form-group">
                      <label for="villages">Village</label>
                      <model-select
                        class="form-control"
                        id="villages"
                        :options="villageList"
                        v-model="$v.ownerCoverageForm.villages.$model"
                        :isError="$v.ownerCoverageForm.villages.$invalid"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.ownerCoverageForm.villages.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Village should be filled.
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
          <CCol lg="6">
            <p>Perhatian!!</p>
            <p>
              Jika district dan villages tidak di isi, maka asumsi seluruh district dan village maka akan secara otomatis terisi.<br/>
              Sebagai contoh, jika hanya provinsi Jawa Barat, dan Regency Kab. Bogor yang di isi, maka seluruh district dari Provinsi jawa barat dan Regency Kab. Bogor akan otomatis terisi
            </p>
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.ownerCoverageForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "OwnerCoverage",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "OwnerCoverage",
      items: [],
      addButton: false,
      isEdit: false,
      isLoading: false,
      ownerCoverageForm: tableInterfaces.owner_coverage,
      activeTab: 0,
      regencyList: [],
      districtList: [],
      villageList: [],
      //   checkedFlag: "Agent",
      fields: [
        { key: "province_name", label: "Provinsi", sorter: true },
        { key: "regencies_name", label: "Kecamatan/Kabupaten", sorter: true },
        { key: "district_name", label: "Distrik/Rayon", sorter: true },
        { key: "villages_name", label: "Kampung", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
    };
  },
  props: {
    owner: {
      type: [Array, Object],
      default: () => [],
    },
    provinceList: {
      type: [Array, Object],
      default: () => [],
    },
    ownerCoverage: {
      type: [Array, Object],
      default: () => [],
    },
    ownerStatus: {
      type: String,
      default: "",
    },
  },
  validations: {
    ownerCoverageForm: {
      province: { required },
      regencies: { required },
      district: {},
      villages: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    data: function () {
      return this.items.length > 0 ? this.items : this.ownerCoverage;
    },
  },
  methods: {
    init: function () {},
    refreshOwnerCoverage: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/freezer_owner/owner_coverage/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.isEdit = true;
      this.ownerCoverageForm = item;
      this.callRegencies();
      this.callDistrict();
      this.callVillage();
      this.ownerCoverageForm.id = item.id;
      this.addButton = true;
    },
    removeData: function (item) {
      if (confirm("Do you want to remove this data ?")) {
        this.isLoading = false;
        this.axios
          .delete("console/freezer_owner/owner_coverage/" + item.id)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.refreshOwnerCoverage(this.owner.id);
          });
      }
      // bikin api untuk remove
    },
    resetForm: function () {
      for (var i in tableInterfaces.owner_coverage) {
        tableInterfaces.owner_coverage[i] = null;
      }
      this.ownerCoverageForm = tableInterfaces.owner_coverage;
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (event) {
      event.preventDefault();
      this.ownerCoverageForm.freezer_owner_code = this.owner.freezer_owner_code;
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/freezer_owner/owner_coverage/update", this.ownerCoverageForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshOwnerCoverage(this.owner.id);
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/freezer_owner/owner_coverage/add", this.ownerCoverageForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshOwnerCoverage(this.owner.id);
            });
        }
      }
    },
    filterRegency: function () {
      this.ownerCoverageForm.regencies = null;
      this.ownerCoverageForm.district = null;
      this.ownerCoverageForm.villages = null;
      this.regencyList = [];
      this.districtList = [];
      this.villageList = [];
      this.axios
        .get("/console/dropdown/regency/" + this.ownerCoverageForm.province)
        .then((response) => {
          this.regencyList = response.data.data;
        });
    },
    filterDistrict: function () {
      this.ownerCoverageForm.district = null;
      this.ownerCoverageForm.villages = null;
      this.districtList = [];
      this.villageList = [];
      this.axios
        .get("/console/dropdown/district/" + this.ownerCoverageForm.regencies)
        .then((response) => {
          this.districtList = response.data.data;
        });
    },
    filterVillage: function () {
      this.ownerCoverageForm.villages = null;
      this.villageList = [];
      this.axios
        .get("/console/dropdown/village/" + this.ownerCoverageForm.district)
        .then((response) => {
          this.villageList = response.data.data;
        });
    },
    callRegencies: function () {
      this.axios
        .get("/console/dropdown/regency/" + this.ownerCoverageForm.province)
        .then((response) => {
          this.regencyList = response.data.data;
        });
    },
    callDistrict: function () {
      this.axios
        .get("/console/dropdown/district/" + this.ownerCoverageForm.regencies)
        .then((response) => {
          this.districtList = response.data.data;
        });
    },
    callVillage: function () {
      this.axios
        .get("/console/dropdown/village/" + this.ownerCoverageForm.district)
        .then((response) => {
          this.villageList = response.data.data;
        });
    },
  },
  mounted() {},
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
